import React from "react";
import IndividualMobileCard from "../IndividualAccountsTab/IndividualMobileCard";

import NonIndividualDetailsAccordian from "./NonIndividualDetailsAccordian";
import NonIndividualEmailCard from "./NonIndividualEmailCard";
import NonIndividualMobileCard from "./NonIndividualMobileCard";
function NonIndividualAccountSections() {

      
    return (
        <div className="individual-acc-section">
            <div className="wrap-mob-email">
                <NonIndividualMobileCard 
                />
                <NonIndividualEmailCard />
            </div>
            <NonIndividualDetailsAccordian
            />
        </div>
    );
}

export default NonIndividualAccountSections;
